@if (isExternalUrl()) {
  <a customButtonSwitch
    role="link"
    [href]="url"
    [attr.target]="target"
    [attr.rel]="rel"
    [attr.id]="id"
    [attr.class]="class"
    [attr.style]="style"
    [attr.title]="title"
    [attr.aria-label]="ariaLabel ? ariaLabel : null"
    [tabindex]="tabindex"
    (click)="menuToCategory(isMenu)"
    routerLinkActive="active"
    >
    @if (icon) {
      <cx-media [container]="icon"></cx-media>
    }
    <span><ng-container *ngTemplateOutlet="content"></ng-container></span>
  </a>
} @else {
  <a customButtonSwitch
    role="link"
    [routerLink]="routerUrl"
    [queryParams]="queryParams"
    [fragment]="fragment"
    [target]="target || undefined"
    [attr.id]="id"
    [attr.class]="class"
    [attr.style]="style"
    [attr.title]="title"
    (click)="menuToCategory(isMenu)"
    routerLinkActive="active"
    >
    @if (icon) {
      <cx-media [container]="icon"></cx-media>
    }
    <span><ng-container *ngTemplateOutlet="content"></ng-container></span>
  </a>
}


<ng-template #content>
  <ng-content></ng-content>
</ng-template>
